/**
 * ChatViewContext
 * 
 * Signals when the mobile chat channel view is active.
 * Used to hide the MobileBottomNav when inside a chat conversation.
 */
import React, { createContext, useContext, useState, useCallback } from 'react';

const ChatViewContext = createContext({
  isInChatView: false,
  enterChatView: () => {},
  exitChatView: () => {},
});

export function ChatViewProvider({ children }) {
  const [isInChatView, setIsInChatView] = useState(false);
  
  const enterChatView = useCallback(() => {
    setIsInChatView(true);
  }, []);
  
  const exitChatView = useCallback(() => {
    setIsInChatView(false);
  }, []);
  
  return (
    <ChatViewContext.Provider value={{ isInChatView, enterChatView, exitChatView }}>
      {children}
    </ChatViewContext.Provider>
  );
}

export function useChatView() {
  return useContext(ChatViewContext);
}

export default ChatViewContext;
